<template>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout>
      <v-flex xs12>
        <v-card :elevation="$vuetify.breakpoint.smAndDown ? 0 : 2">
          <balance-toolbar
            @updateDocumentsList="getDocumentsList"
          />
          <loading v-if="tableLoading"/>
          <component
            v-else-if="content.length"
            :is="balanceDisplayComponent"
            :content="content"
            :currencies="currencies"
            :openableDocuments="openableDocuments"
            :loading="tableLoading"
          />
          <empty-table
            v-else
            :emptyText="'Нет документов'"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BalanceToolbar from './BalanceToolbar'
import BalanceTable from './BalanceTable'
import BalanceList from './BalanceList'
import BalanceApi from '../api'
import emptyTable from '@/components/helpers/EmptyTable'
import Loading from '@/components/helpers/Loading'
import { format } from 'date-fns'

export default {
  name: 'balance',
  components: {
    BalanceToolbar,
    BalanceTable,
    BalanceList,
    Loading,
    emptyTable
  },
  data () {
    return {
      format,
      document: false,
      currencies: {},
      tableLoading: false,
      openableDocuments: [
        'rashodnayanakladnaya',
        'prihodnayanakladnaya',
        'vozvratnayanakladnaya',
        'rashodnayanakladnaya_zakaz',
        'vozvratnayanakladnaya_zakaz',
        'zakaznayaprihodnaya'
      ],
      content: []
    }
  },
  computed: {
    balanceDisplayComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'balance-list' : 'balance-table'
    }
  },
  methods: {
    async getDocumentsList (selectedDates) {
      this.tableLoading = true
      let payload = {
        dateStart: selectedDates ? format(selectedDates[0], 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD'),
        dateEnd: selectedDates ? format(selectedDates[1] || selectedDates[0], 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD')
      }
      let response = await BalanceApi.getList(payload)
      if (response.success) {
        this.content = response.data
        this.currencies = response.currencies
      } else {
        console.log(response.error)
      }
      this.tableLoading = false
    }
  },

  mounted () {
    if (this.$route.query.from && this.$route.query.to) {
      this.getDocumentsList([this.$route.query.from, this.$route.query.to])
    } else {
      this.getDocumentsList()
    }
  }
}
</script>

<style lang="stylus">
  @media screen and (max-width: 599px)
    .flatpickr-calendar
      position fixed
      top 20% !important
      left 50% !important
      margin-left -154px
      border-radius 0
</style>
